<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M32 61.333C48.2 61.333 61.333 48.2 61.333 32S48.2 2.667 32 2.667 2.667 15.8 2.667 32c0 1.568 1.27 2.839 2.838 2.839s2.84-1.271 2.84-2.839C8.344 18.935 18.934 8.344 32 8.344c13.065 0 23.656 10.591 23.656 23.656S45.065 55.656 32 55.656c-1.568 0-2.839 1.27-2.839 2.839 0 1.567 1.271 2.838 2.839 2.838z" transform="translate(-786 -911) translate(786 911)"/>
            </g>
        </g>
    </g>
</svg>
